<template>
  <section class="wrapper">
    <van-row class="mt10" :gutter="5">
      <van-col :span="6">
        <van-button block size="small" :type="currentUrl==='mark'?'primary':'default'" @click="goto('mark')">记录收款
        </van-button>
      </van-col>
      <van-col :span="6">
        <van-button block size="small" :type="currentUrl==='search-record'?'primary':'default'" @click="goto('search-record')">
          查询收款与销账
        </van-button>
      </van-col>
      <van-col :span="6">
        <van-button block size="small" :type="currentUrl==='report'?'primary':'default'" @click="goto('report')">申报收入外收款
        </van-button>
      </van-col>
      <van-col :span="6">
        <van-button block size="small" :type="currentUrl==='search-collection'?'primary':'default'"
                    @click="goto('search-collection')">
          查询收入外收款记录
        </van-button>
      </van-col>
    </van-row>
    <router-view class="content"></router-view>
  </section>
</template>
<script>
  export default {
    data() {
      return {
        currentUrl: ''
      }
    },
    methods: {
      goto(url) {
        this.$router.push(`/collection/${url}`)
      }
    },
    watch: {
      $route: {
        handler(to, from) {
          if (to.path.indexOf('mark') >= 0) {
            this.currentUrl = 'mark'
          } else if (to.path.indexOf('search-record') >= 0) {
            this.currentUrl = 'search-record'
          } else if (to.path.indexOf('search-collection') >= 0) {
            this.currentUrl = 'search-collection'
          } else if (to.path.indexOf('report') >= 0) {
            this.currentUrl = 'report'
          }
        },
        immediate: true
      }
    }
  }
</script>

<style lang="less" scoped>
  .wrapper {
    padding:0 1rem;
  }

  .content {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    height: calc(100% - 10rem);
    overflow: hidden;
  }

</style>
<!--<script>-->
<!--  import vuePickers from 'vue-pickers'-->

<!--  export default {-->
<!--    name: "Recordreceipts",-->
<!--    components: {-->
<!--      vuePickers-->
<!--    },-->
<!--    data() {-->
<!--      return {-->
<!--        subcategory: '',-->
<!--        isshow5: false,-->
<!--        subcatelist: [],-->
<!--        subcacon: {-->
<!--          data1: [{-->
<!--            text: '1111',-->
<!--            value: '1111'-->
<!--          }]-->
<!--        },-->
<!--        show: false,-->
<!--        isshow: false,-->
<!--        isshow1: false,-->
<!--        isshow2: false,-->
<!--        isshow3: false,-->
<!--        isshow4: false,-->
<!--        currencyList: [],-->
<!--        selectBirthDate: '',-->
<!--        columns: 1,-->
<!--        funds: '',-->
<!--        customerList: [],-->
<!--        currencyCon: {-->
<!--          data1: [{-->
<!--            text: '',-->
<!--            value: ''-->
<!--          }]-->
<!--        },-->
<!--        customercon: {-->
<!--          data1: [{-->
<!--            text: '1111',-->
<!--            value: '1111'-->
<!--          }]-->
<!--        },-->
<!--        fundsconlist: [],-->
<!--        fundscon: {-->
<!--          data1: [-->
<!--            {-->
<!--              text: '111',-->
<!--              value: '111'-->
<!--            }-->
<!--          ]-->
<!--        },-->
<!--        InvTypecon: {-->
<!--          data1: [-->
<!--            {-->
<!--              text: '经营活动收款',-->
<!--              value: '经营活动收款'-->
<!--            },-->
<!--            {-->
<!--              text: '投资活动收款',-->
<!--              value: '投资活动收款'-->
<!--            },-->
<!--            {-->
<!--              text: '筹资活动收款',-->
<!--              value: '筹资活动收款'-->
<!--            }-->
<!--          ],-->
<!--        },-->
<!--        InvTypeDtscon: {-->
<!--          data1: [{-->
<!--            text: '',-->
<!--            value: ''-->
<!--          }]-->
<!--        },-->
<!--        Log_c: '',-->
<!--        RP_GUID: '',-->
<!--        Operation: '',-->
<!--        RPer: '',-->
<!--        Date: '',-->
<!--        SumAmount: '',-->
<!--        Remark: '',-->
<!--        Mark: '',-->
<!--        Record: '',-->
<!--        Currency: '',-->
<!--        IE_GUID: '',-->
<!--        Log: '',-->
<!--        InvType: '',-->
<!--        InvTypeDts: '',-->
<!--        InvNo: '',-->
<!--        DisAmount: '',-->
<!--        PayCategoryID: '',-->
<!--        DetailRPTypeID: '',-->
<!--        PayCategory: '',-->
<!--        BA_GUID: '',-->
<!--        Creator: '',-->
<!--        C_GUID: '',-->
<!--        RP_Flag: '',-->
<!--      }-->
<!--    },-->
<!--    mounted() {-->
<!--      this.BirthDateSelect()-->
<!--      this.getcurrency()-->
<!--      this.GetCustomer()-->
<!--      this.GetBankInfo();-->
<!--      this.GetPayOrReceivablesType()-->
<!--    },-->
<!--    methods: {-->
<!--      submitcollection() {-->
<!--        let parms = JSON.stringify({-->
<!--          Log_c: 'a',-->
<!--          RP_GUID: "",-->
<!--          Operation: '',-->
<!--          RPer: sessionStorage.getItem('RPercon'),-->
<!--          Date: this.selectBirthDate.replace(/年/g, "/").replace(/月/g, "/").replace(/日/g, ""),-->
<!--          SumAmount: this.SumAmount,-->
<!--          Remark: '',-->
<!--          Mark: '',-->
<!--          Record: '',-->
<!--          Currency: this.Currency,-->
<!--          IE_GUID: '',-->
<!--          Log: this.Log,-->
<!--          InvType: this.InvType,-->
<!--          InvTypeDts: this.InvTypeDts,-->
<!--          InvNo: '',-->
<!--          DisAmount: '0',-->
<!--          PayCategoryID: sessionStorage.getItem('payid'),-->
<!--          DetailRPTypeID: sessionStorage.getItem('bankId'),-->
<!--          PayCategory: this.funds,-->
<!--          BA_GUID: '',-->
<!--          Creator: '',-->
<!--          C_GUID: sessionStorage.getItem('companyId'),-->
<!--        })-->
<!--        this.$axios.post('/fmsapi/ReceivablesRecord/CreateReceivablesRecord', parms, {-->
<!--          headers: {-->
<!--            'Content-Type': 'application/json;'-->
<!--          }-->
<!--        }).then(res => {-->
<!--          alert("提交成功")-->

<!--          this.$router.push({path: "/home"})-->
<!--        })-->
<!--      },-->
<!--      GetBankInfo() {-->
<!--        this.$axios({-->
<!--          method: 'post',-->
<!--          url: '/fmsapi/common/GetBankInfo',-->
<!--          data: this.$qs.stringify({-->
<!--            cGuid: sessionStorage.getItem('companyId')-->
<!--          })-->
<!--        }).then(res => {-->
<!--          this.subcatelist = res.data-->
<!--          this.subcacon.data1 = new Array()-->
<!--          console.log(this.subcatelist)-->
<!--          for (var i = 0; i < this.subcatelist.length; i++) {-->
<!--            this.subcacon.data1.push({-->
<!--              'text': this.subcatelist[i].label,-->
<!--              'value': this.subcatelist[i].label,-->
<!--              'bankId': this.subcatelist[i].value-->
<!--            })-->
<!--          }-->

<!--        })-->
<!--      },-->
<!--      GetPayOrReceivablesType() {-->
<!--        this.$axios({-->
<!--          method: 'post',-->
<!--          url: '/fmsapi/common/GetPayOrReceivablesType',-->
<!--          data: this.$qs.stringify({-->
<!--            cGuid: sessionStorage.getItem('companyId')-->
<!--          })-->
<!--        }).then(res => {-->
<!--          this.fundsconlist = res.data-->
<!--          this.fundscon.data1 = new Array();-->
<!--          console.log(res.data)-->
<!--          for (var i = 0; i < this.fundsconlist.length; i++) {-->
<!--            this.fundscon.data1.push({-->
<!--              "text": this.fundsconlist[i].label,-->
<!--              'value': this.fundsconlist[i].label,-->
<!--              'payid': this.fundsconlist[i].value-->
<!--            })-->
<!--            console.log(this.fundsconlist[i])-->
<!--          }-->
<!--          console.log(res.data)-->
<!--        })-->
<!--      },-->
<!--      InvTypecons(val) {-->
<!--        var btn2 = document.getElementById('chose')-->
<!--        this.isshow1 = false-->
<!--        btn2.value = val.select1.value-->
<!--        this.InvType = btn2.value-->
<!--        this.$axios({-->
<!--          method: 'post',-->
<!--          url: '/fmsapi/PaymentRecord/GetStreamAccountShip',-->
<!--          data: this.$qs.stringify({-->
<!--            streamFlag: 'R'-->
<!--          })-->
<!--        }).then(res => {-->
<!--          this.InvTypeList = res.data.result-->
<!--          this.InvTypeDtscon.data1 = new Array()-->
<!--          console.log(this.InvTypeList)-->
<!--          for (var i = 0; i < this.InvTypeList.length; i++) {-->
<!--            console.log(this.InvType)-->
<!--            if (this.InvTypeList[i].GroupName === this.InvType) {-->
<!--              this.InvTypeDtscon.data1.push({"text": this.InvTypeList[i].LASName, "value": this.InvTypeList[i].LASName})-->
<!--              console.log(this.InvTypeDtscon)-->
<!--            }-->
<!--          }-->
<!--        })-->
<!--      },-->
<!--      subcatecon(val) {-->
<!--        var sub = document.getElementById('sub')-->
<!--        this.isshow5 = false-->
<!--        sessionStorage.setItem('bankId', val.select1.bankId)-->
<!--        sub.value = val.select1.value-->
<!--        this.subcategory = sub.value-->
<!--      },-->
<!--      close5() {-->
<!--        this.isshow5 = false-->
<!--      },-->
<!--      tosub(val) {-->
<!--        if (this.funds === '银行存款') {-->
<!--          this.isshow5 = true-->
<!--        } else {-->
<!--          this.isshow5 = false-->
<!--        }-->
<!--      },-->
<!--      toInvTy(val) {-->
<!--        this.isshow1 = true-->
<!--      },-->
<!--      toIny(val) {-->
<!--        if (this.InvType !== '') {-->
<!--          this.isshow2 = true-->
<!--        } else {-->
<!--          this.isshow2 = false-->
<!--        }-->

<!--      },-->
<!--      InvTypes(val) {-->
<!--        var btn3 = document.getElementById('chose1')-->
<!--        this.isshow2 = false-->
<!--        btn3.value = val.select1.value-->
<!--        this.InvTypeDts = btn3.value-->
<!--      },-->
<!--      close2() {-->
<!--        console.log(123)-->
<!--        this.isshow1 = false-->
<!--      },-->
<!--      close() {-->
<!--        console.log(123)-->
<!--        this.show = false-->
<!--      },-->
<!--      close1() {-->
<!--        console.log(123)-->
<!--        this.isshow = false-->
<!--      },-->
<!--      close4() {-->
<!--        console.log(123)-->
<!--        this.isshow4 = false-->
<!--      },-->
<!--      close3() {-->
<!--        console.log(123)-->
<!--        this.isshow2 = false-->
<!--      },-->
<!--      currycon(val) {-->
<!--        var btn = document.getElementById('btncon')-->
<!--        this.show = false-->
<!--        btn.value = val.select1.value-->
<!--        this.Currency = btn.value-->
<!--        // console.log(JSON.parse(this.defaultData))-->
<!--      },-->

<!--      concus(val) {-->
<!--        var btn1 = document.getElementById('btncon1')-->
<!--        console.log(val.select1.value)-->
<!--        this.isshow = false-->
<!--        sessionStorage.setItem('RPercon', val.select1.RPercon)-->
<!--        btn1.value = val.select1.value-->
<!--        this.res = btn1.value-->
<!--        // console.log(JSON.parse(this.defaultData))-->
<!--      },-->

<!--      fundsCon(val) {-->
<!--        var btn2 = document.getElementById('btncon2')-->
<!--        this.isshow4 = false-->
<!--        sessionStorage.setItem('payid', val.select1.payid)-->
<!--        btn2.value = val.select1.value-->
<!--        this.funds = btn2.value-->
<!--        // console.log(JSON.parse(this.defaultData))-->
<!--      },-->
<!--      categoryCon(val) {-->
<!--        var btn3 = document.getElementById('btncon3')-->
<!--        console.log(val.select1.value)-->
<!--        this.isshow3 = false-->
<!--        btn3.value = val.select1.value-->
<!--        this.res = btn3.value-->
<!--        // console.log(JSON.parse(this.defaultData))-->
<!--      },-->
<!--      toCurry(val) {-->
<!--        this.show = true-->
<!--        // var btn=document.getElementById('btn')-->
<!--        // console.log(val)-->
<!--        // this.res = btn.value-->
<!--      },-->
<!--      toCus(val) {-->
<!--        this.isshow = true-->
<!--        // var btn=document.getElementById('btn')-->
<!--        // console.log(val)-->
<!--        // this.res = btn.value-->
<!--      },-->
<!--      tofunds(val) {-->
<!--        this.isshow4 = true-->
<!--        // var btn=document.getElementById('btn')-->
<!--        // console.log(val)-->
<!--        // this.res = btn.value-->
<!--      },-->
<!--      tocategory(val) {-->
<!--        this.isshow3 = true-->
<!--        // var btn=document.getElementById('btn')-->
<!--        // console.log(val)-->
<!--        // this.res = btn.value-->
<!--      },-->
<!--      Dec() {-->
<!--        this.$router.push({path: '/Dec'})-->
<!--      },-->
<!--      GetCustomer() {-->
<!--        var custormlog = document.getElementById('custormlog')-->
<!--        this.$axios({-->
<!--          method: 'post',-->
<!--          url: '/fmsapi/common/GetPartnersAll',-->
<!--          data: this.$qs.stringify({-->
<!--            C_GUID: sessionStorage.getItem('companyId')-->
<!--          })-->
<!--        }).then(res => {-->
<!--          this.customerList = res.data.result-->
<!--          // custormlog.style.display="block"-->
<!--          console.log(res.data)-->
<!--          this.customercon.data1 = new Array();-->
<!--          for (var i = 0; i < this.customerList.length; i++) {-->
<!--            this.customercon.data1.push({-->
<!--              "text": this.customerList[i].Name,-->
<!--              "value": this.customerList[i].Name,-->
<!--              'RPercon': this.customerList[i].BP_GUID-->
<!--            })-->
<!--          }-->
<!--        })-->
<!--      },-->
<!--      BirthDateSelect() {-->
<!--        var calendar = new datePicker();-->
<!--        calendar.init({-->
<!--          trigger: ".js-startdate-picker", /*按钮选择器，用于触发弹出插件*/-->
<!--          type:-->
<!--            "date" /*模式：date日期；datetime日期时间；time时间；ym年月；year:年*/,-->
<!--          minDate: "1900-1-1" /*最小日期*/,-->
<!--          maxDate: "2100-12-31" /*最大日期*/,-->
<!--          onSubmit: function () {-->
<!--            /*确认时触发事件*/-->
<!--            var theSelectData = calendar.value;-->
<!--          },-->
<!--          onClose: function () {-->
<!--            /*取消时触发事件*/-->
<!--          }-->
<!--        });-->
<!--      },-->
<!--      getcurrency() {-->
<!--        var currency = document.getElementById('currency')-->
<!--        this.$axios.post('/fmsapi/common/GetSearchCurrency').then(res => {-->
<!--          this.currencyList = res.data.result-->
<!--          this.currencyCon.data1 = new Array();-->
<!--          for (var i = 0; i < this.currencyList.length; i++) {-->
<!--            this.currencyCon.data1.push({"text": this.currencyList[i].Code, "value": this.currencyList[i].Code})-->
<!--          }-->

<!--        })-->
<!--      },-->
<!--      curry(i) {-->
<!--        var currency = document.getElementById('currency')-->
<!--        var getcurrency = document.getElementById('getcurrency')-->
<!--        getcurrency.value = i.Code-->
<!--        currency.style.display = 'none'-->
<!--      },-->
<!--      findrecord() {-->
<!--        this.$router.push({path: '/findrecord'})-->
<!--      },-->
<!--      back() {-->
<!--        this.$router.push('/home')-->
<!--      },-->
<!--      findcollection() {-->
<!--        this.$router.push({path: '/findcollection'})-->
<!--      },-->
<!--      Fromrece() {-->
<!--        this.$router.push({path: '/fromrece'})-->
<!--      }-->
<!--    }-->
<!--  }-->
<!--</script>-->

<!--<style lang="less" scoped>-->
<!--  .wrapper {-->
<!--    overflow: auto;-->
<!--    height: 100%;-->
<!--    background: white;-->
<!--  }-->
<!--</style>-->
